export interface UtmParams {
	utm_source?: string;
	utm_medium?: string;
	utm_campaign?: string;
	utm_term?: string;
	utm_content?: string;
}

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const UTM_STORAGE_KEY = 'akonia_utm_params';

/**
 * Extracts UTM parameters from URL and merges them with
 * existing stored params in sessionStorage.
 * New params override existing ones for the same key,
 * but previously-set keys are preserved if not present in the URL.
 */
export function storeUtmParams(url: URL) {
	if (typeof window === 'undefined') return;

	const newParams: Record<string, string> = {};
	let hasNewParams = false;

	UTM_KEYS.forEach(key => {
		const value = url.searchParams.get(key);
		if (value) {
			newParams[key] = value;
			hasNewParams = true;
		}
	});

	if (hasNewParams) {
		// Merge with existing stored params — new values override, old preserved
		const existing: Record<string, string> = {};
		try {
			const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
			if (stored) Object.assign(existing, JSON.parse(stored));
		} catch { /* ignore parse errors */ }

		sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify({ ...existing, ...newParams }));
	}
}

/**
 * Retrieves stored UTM parameters from sessionStorage
 */
export function getUtmParams(): UtmParams {
	if (typeof window === 'undefined') return {};

	try {
		const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
		if (stored) {
			return JSON.parse(stored);
		}
	} catch {
		// Silently ignore parse errors
	}
	return {};
}
